window.addEventListener('DOMContentLoaded', initLogos);

function initLogos() {
  document.querySelectorAll('body:not(.neos-backend) .c-logos').forEach(logos => {
    const row = logos.querySelector('.c-animated-row');
    if (!row) return;
    const clone = row.cloneNode(true);
    logos.appendChild(clone);
  });
}
